/** Subscription banners: free-plan trial CTA, trialing countdown, active-plan strip. */
export const PlanBanners = ({ user, isPro, upgrade, cancelPlan }) => {
  return (
    <>
      {!isPro && (
        <div className="bg-[#007AFF]/10 border-b border-[#007AFF]/30 px-4 md:px-6 py-3 flex flex-wrap gap-3 items-center justify-between" data-testid="upgrade-banner">
          <div className="text-sm">
            <span className="text-[#007AFF] font-bold uppercase tracking-wider">Free plan ·</span>
            <span className="ml-2 text-zinc-300">Start a <b>3-day free trial</b> — full Pro access. Cancel anytime in the first 3 days, no charge.</span>
          </div>
          <div className="flex gap-2 flex-wrap" data-testid="trial-plan-buttons">
            <button onClick={() => upgrade("indian_monthly")} className="border border-[#F59E0B]/50 hover:border-[#F59E0B] text-xs font-bold uppercase tracking-wider px-3 py-2" data-testid="trial-monthly-btn">Monthly → ₹2,999/mo · Intro offer</button>
            <button onClick={() => upgrade("indian_annual")} className="bg-[#007AFF] hover:bg-[#3395FF] text-xs font-bold uppercase tracking-wider px-3 py-2" data-testid="trial-annual-btn">Annual → ₹29,999/yr · 2 months free</button>
          </div>
        </div>
      )}
      {user?.status === "trialing" && user?.trial_ends_at && (
        <div className="bg-[#22C55E]/10 border-b border-[#22C55E]/30 px-4 md:px-6 py-3 flex flex-wrap gap-3 items-center justify-between" data-testid="trial-banner">
          <div className="text-sm">
            <span className="text-[#22C55E] font-bold uppercase tracking-wider">Trial active ·</span>
            <span className="ml-2 text-zinc-300">Full Pro access. Auto-charge on <span className="font-mono">{new Date(user.trial_ends_at).toLocaleString()}</span>.</span>
          </div>
          <button onClick={cancelPlan} className="border border-zinc-700 hover:border-[#EF4444] hover:text-[#EF4444] text-xs font-bold uppercase tracking-wider px-3 py-2" data-testid="cancel-trial-btn">Cancel trial</button>
        </div>
      )}
      {user?.status === "active" && (
        <div className="bg-zinc-900/60 border-b border-zinc-800 px-4 md:px-6 py-2 flex flex-wrap gap-3 items-center justify-between text-xs" data-testid="active-banner">
          <span className="text-zinc-400">
            <span className="text-[#22C55E] uppercase tracking-widest font-bold">Pro · {user.plan_tier}</span>
            {user.plan_expires_at && <span className="ml-2 text-zinc-500 font-mono">renews {new Date(user.plan_expires_at).toLocaleDateString()}</span>}
          </span>
          <button onClick={cancelPlan} className="text-zinc-500 hover:text-[#EF4444] uppercase tracking-widest font-bold" data-testid="cancel-active-btn">Cancel</button>
        </div>
      )}
    </>
  );
};
